import { gql } from '@apollo/client';

const GET_TASK_LIST_TEMPLATES = gql`
  query GetTaskListTemplates(
    $first: Int
    $after: String
    $includePartnerTemplates: Boolean
  ) {
    viewer {
      __typename
      id
      company {
        id
        taskListTemplates(
          first: $first
          after: $after
          includePartnerTemplates: $includePartnerTemplates
        ) {
          nodes {
            id
            name
            description
            isOwner
            beingEdited
            updatedAt
            owner {
              ... on PublicCompany {
                id
                name
                logo
              }
              ... on PublicTaskListPartner {
                id
                name
                logo
              }
              __typename
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;

export default GET_TASK_LIST_TEMPLATES;
